enum Steps {
  Test = 'ONLY USE IN TESTS!!!',

  // Survey
  SurveyBasics = 'Basics',
  Occupation = 'Occupation',
  BenefitAmount = 'Benefit amount',
  WaitingPeriod = 'Waiting period',
  BenefitPeriod = 'Benefit period',
  PolicyFeatures = 'Policy features',

  // Health
  HealthBasics = 'Health Basics',
  BloodPressure = 'Blood pressure profile',
  Diabetes = 'Diabetes profile',
  Depression = 'Depression profile',
  SleepApnea = 'Sleep apnea profile',
}

export default Steps;
